import React from "react";
import { usePageTitle } from "../hooks/usePageTitle";

const Terms = () => {
  usePageTitle("Terms of Service");

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-white mb-6">Terms of Service</h1>
      <p className="text-gray-400 text-sm mb-8">
        Last updated: January 10, 2026
      </p>

      <div className="space-y-8 text-gray-300">
        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing and using Collect Arena ("the Service"), you agree to
            be bound by these Terms of Service. If you do not agree to these
            terms, please do not use our service.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            2. Description of Service
          </h2>
          <p>
            Collect Arena is a knowledge-based quiz platform where users can
            browse curated lists and test their knowledge by guessing hidden
            items. The service is provided "as is" without warranties of any
            kind.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            3. User Accounts
          </h2>
          <p className="mb-3">When you create an account, you agree to:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Provide accurate and complete information</li>
            <li>Maintain the security of your password</li>
            <li>Be responsible for all activity under your account</li>
            <li>Notify us immediately of any unauthorized use</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            4. Acceptable Use
          </h2>
          <p className="mb-3">You agree NOT to:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Use the service for any illegal purpose</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Interfere with or disrupt the service</li>
            <li>Use automated tools (bots, scrapers) without permission</li>
            <li>Harass, abuse, or harm other users</li>
            <li>Upload malicious code or viruses</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            5. Content Ownership
          </h2>
          <p>
            All content on Collect Arena, including lists, categories, and quiz
            data, is owned by Collect Arena or licensed to us. You may not copy,
            distribute, or create derivative works without our permission.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            6. User Data
          </h2>
          <p>
            Your use of the service is also governed by our Privacy Policy. By
            using the service, you consent to our collection and use of data as
            described in the Privacy Policy.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            7. Account Termination
          </h2>
          <p>
            We reserve the right to suspend or terminate your account at any
            time for violation of these terms. You may also delete your account
            at any time through your profile settings.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            8. Limitation of Liability
          </h2>
          <p>
            Collect Arena is provided "as is" without warranties. We are not
            liable for any damages arising from your use of the service,
            including but not limited to direct, indirect, or consequential
            damages.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            9. Changes to Terms
          </h2>
          <p>
            We may modify these terms at any time. Continued use of the service
            after changes constitutes acceptance of the new terms. We will
            notify users of significant changes.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            10. Governing Law
          </h2>
          <p>
            These terms are governed by the laws of the Netherlands. Any
            disputes shall be resolved in the courts of the Netherlands.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-white mb-3">
            11. Contact
          </h2>
          <p>
            For questions about these terms, contact us at:{" "}
            <a
              href="mailto:legal@collectarena.com"
              className="text-blue-400 hover:text-blue-300"
            >
              legal@collectarena.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
